import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Omnicraft Services</title>
        <meta name="description" content="Read the terms and conditions for using Omnicraft Services. Learn about our services, privacy, and intellectual property policies." />
      </Helmet>
      <div className="min-h-screen pt-16">
        <section className="py-12">
          <div className="container-custom max-w-4xl">
            <h1 className="mb-8">Terms and Conditions</h1>
            
            <div className="prose dark:prose-invert max-w-none">
              <p className="text-lg mb-6">Last updated: April 20, 2025</p>
              
              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
                <p>Welcome to Omni Kraft. By accessing our website, you agree to these terms and conditions.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">2. Services</h2>
                <p>We provide various digital services including but not limited to:</p>
                <ul className="list-disc pl-6 mt-2">
                  <li>Web Development</li>
                  <li>Digital Marketing</li>
                  <li>Content Creation</li>
                  <li>Consulting Services</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">3. Privacy Policy</h2>
                <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect and use your data.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">4. Intellectual Property</h2>
                <p>All content on this website is the property of Omni Kraft and is protected by copyright laws.</p>
              </section>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;
